import { contactData } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="max-w-2xl mx-auto">
          <div className="bg-background-100 rounded-2xl p-8 md:p-10 border border-background-200/60 text-center">
            <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-5 flex items-center justify-center rounded-2xl bg-primary-500/10">
              <i className="ri-mail-send-line text-2xl md:text-3xl text-primary-400"></i>
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              {contactData.title}
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8 max-w-lg mx-auto">
              {contactData.desc}
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 md:gap-8">
              <div className="flex items-center gap-3 px-5 py-3 bg-background-50 rounded-xl border border-background-200/60">
                <i className="ri-mail-line text-lg text-primary-400"></i>
                <span className="text-sm text-foreground-700">{contactData.email}</span>
              </div>
              <div className="flex items-center gap-3 px-5 py-3 bg-background-50 rounded-xl border border-background-200/60">
                <i className="ri-wechat-line text-lg text-accent-500"></i>
                <span className="text-sm text-foreground-700">{contactData.wechat}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}